import {performHttpRequest} from "../http";

export async function snapLayer(data) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/snap',
        'POST',
        data
    )
}
